//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { createFieldConfig } from '../../components/QSelectUtils.js'

import BreakTimeTimer from './BreakTimeTimer.vue'

export default {
  components: {
    BreakTimeTimer: BreakTimeTimer
  },
  props: {
    brigade: {
      type: Object,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'black'
    }
  },
  data: function () {
    return {
      loading: false,
      atBreak: null,
      breakType: null,

      leftTimeDinner: null,
      startTime: null,
      remainingOnStartTimeDinner: null,

      typeFieldConfig: createFieldConfig({ allRecordsFn: this.getTypes })
    }
  },
  computed: {
    types: function () {
      if (this.mobile) {
        if (this.leftTimeDinner != null) {
          return [
            { key: 'dinner', name: 'Обед', _disabled: this.leftTimeDinner <= 0, _reasonDisabled: 'Перерыв потрачен' },
            { key: 'accident', name: 'Авария' }
          ]
        } else {
          // Перерыв на обед удалён (нет dinner в списке breakTimeLeft)
          return [
            { key: 'accident', name: 'Авария' }
          ]
        }
      } else {
        return [
          { key: 'accident', name: 'Авария' }
        ]
      }
    },
    propsConfig: function () {
      if (!this.atBreak) {
        if (this.mobile) {
          return {
            type: {
              label: 'Тип перерыва',
              type: 'object',
              required: true,
              searchConfig: this.typeFieldConfig,
              value: this.leftTimeDinner != null && this.leftTimeDinner > 0 ? { key: 'dinner', name: 'Обед' } : { key: 'accident', name: 'Авария' },
              notClearable: this.leftTimeDinner == null || this.leftTimeDinner <= 0
            },
            comment: {
              type: 'text',
              label: 'Комментарий',
              required: true,
              hideFn: (propsConfig) => propsConfig.type.value && propsConfig.type.value.key !== 'accident'
            }
          }
        } else {
          return {
            declineManualRequests: {
              type: 'boolean', label: 'Очистить очередь назначенных вручную'
            },
            comment: {
              type: 'text', label: 'Комментарий', required: true
            }
          }
        }
      } else {
        return {}
      }
    }
  },
  watch: {
    brigade: {
      handler: function () {
        if (this.brigade) {
          this.setBreakTimeData(this.brigade)
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /**
     * @param breakInfo - объект с данными о перерывах бригады, либо сама бригада с параметрами перерыва
     */
    setBreakTimeData: function (breakInfo, start) {
      this.atBreak = breakInfo.atBreak
      this.breakType = breakInfo.breakType
      this.startTime = breakInfo.breakStartTime

      if (this.mobile) {
        const dinnerBreak = breakInfo.breakTimeLeft.find(b => b.name === 'dinner') || null
        if (dinnerBreak) {
          this.leftTimeDinner = dinnerBreak.leftTime
          if (start) {
            this.remainingOnStartTimeDinner = dinnerBreak.leftTime
          }

          if (this.leftTimeDinner == 0 && this.breakType === 'dinner') { // т.к. atBreak обновляется в течении минуты,
            this.atBreak = false // то при leftTimeDinner = 0, atBreak автоматически выставляется в false
          }
        }
      }
    },
    onBreakTimerVisibilityChange: function () {
      this.updateBrigade()
    },
    attemptToBreakTime: function () {
      if (!this.mobile && this.atBreak && this.breakType !== 'accident') {
        return
      }

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            if (!this.mobile) {
              data.type = 'accident'
            }
            this.onBreakButton(data)
          }
        },
        header: this.mobile ? (this.atBreak ? 'Возобновление работы' : 'Приостановка работы') : 'Авария',
        warning: 'Вы хотите ' + (this.atBreak ? 'возобновить ' : 'приостановить ') + 'работу' + (!this.mobile ? ' бригады' : '') + '?',
        propsConfig: this.propsConfig,
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    onBreakButton: function (data) {
      if (this.atBreak) {
        this.onEndBreakTime(data)
      } else {
        this.onStartBreakTime(data)
      }
    },
    onStartBreakTime: function (data) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      this.startTime = Date.now()

      let url = '/service/delta/journal/brigadeWorkShiftBreak/begin?id=' + this.brigade.id + '&type=' + data.type

      if (data.comment != null) {
        url += '&comment=' + data.comment
      }
      if (data.declineManualRequests != null) {
        url += '&declineManualRequests=' + data.declineManualRequests
      }

      axiosGet({
        url: url,
        onSuccess: () => {
          if (this.mobile) {
            this.updateBrigade(true)
          } else {
            this.$emit('update')
          }

          this.$q.notify({
            type: 'positive',
            message: 'Работа приостановлена',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    onEndBreakTime: function (data) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      const url = '/service/delta/journal/brigadeWorkShiftBreak/end?id=' + this.brigade.id

      axiosGet({
        url: url,
        onSuccess: (response) => {
          this.stopTimer = true
          this.atBreak = false
          this.breakType = null

          if (!this.mobile) {
            this.$emit('update')
          }

          this.$q.notify({
            type: 'positive',
            message: 'Работа возобновлена',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    updateBrigade: function (start) {
      return axiosGet({
        url: 'service/delta/brigade/getBreakInfo',
        // url: 'service/delta/brigade/getBreakInfo?id=' + this.$store.getters.getUser.employee.brigadeId,
        onSuccess: (response) => {
          const breakInfo = response.data
          this.setBreakTimeData(breakInfo, start)
        }
      })
    },
    getTypes: function () {
      return Promise.resolve(this.types)
    },
    getBreakName: function () {
      if (this.breakType === 'dinner') {
        return 'Обед'
      } else if (this.breakType === 'accident' || !this.mobile) {
        return 'Авария'
      } else {
        return null
      }
    },
    getIcon: function () {
      if (this.breakType === 'dinner') {
        return 'mdi-silverware-variant'
      } else if (this.breakType === 'accident' || !this.mobile) {
        return 'mdi-triangle-outline'
      } else {
        return 'mdi-pause-circle-outline'
      }
    }
  }
}

